import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

import { SegmentTrackEvent } from '@ninety/mobile/platform/services';

import { SegmentActions } from '../analytics/segment/segment.actions';

import { SignUpStateActions } from './sign-up-state.actions';

export class SignUpStateAnalyticsEffects {
  private readonly actions$ = inject(Actions);

  signUpClicked$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SignUpStateActions.signUp),
      map(() =>
        SegmentActions.trackAnonymousEvent({
          event: SegmentTrackEvent.SIGN_UP_CLICKED,
          params: {
            nativeApp: true,
          },
        })
      )
    )
  );
}
